module.exports = __webpack_public_path__ + "assets/48b1db4d76f897861a3c4e6a903a22ec.mp3";